import { status } from 'src/colors';

export const getBooleanStatusColor = (conditionMet: boolean) => {
  if (conditionMet) {
    return status.success;
  }

  return status.error;
};
